import { SnackbarProvider } from "notistack";
import RouterRoot from "./routes";

function App() {
  return (
    <SnackbarProvider>
      <RouterRoot />
    </SnackbarProvider>
  );
}

export default App;
